export const loginRoutes = [
  'auth/login',
  '2fa-verify-otp',
  'user/roaming-confirm-email',
  'user/roaming-validate-token',
  'user/forgot-password',
  'user/third-party-user/login',
];
